import { z } from 'zod'

const CompetitorSchema = z.object({
  id: z.number(),
  player_1: z.string(),
  player_2: z.string().optional()
})

const PlayerSchema = z.object({
  id: z.number(),
  first_name: z.string(),
  last_name: z.string(),
  display_name: z.string(),
})

const MatchPlayerSchema = z.object({
  competitor_no: z.number(),
  serve_no: z.number(),
}).merge(PlayerSchema)

const StatisticsSchema = z.object({
  '1s': z.number().nullable().optional(),
  '11s': z.number().nullable().optional(),
  '12s': z.number().nullable().optional(),
  '1g': z.number().nullable().optional(),
  '1b': z.number().nullable().optional(),
  '1tb': z.number().nullable().optional(),
  '1stb': z.number().nullable().optional(),
  '1brk': z.number().nullable().optional(),
  '11b': z.number().nullable().optional(), // 11 served and lost
  '12b': z.number().nullable().optional(), // 12 served and lost
  '1b_st_empty': z.number().nullable().optional(), // Team 1 empty shot types
  '1b_st_forehand': z.number().nullable().optional(),
  '1b_st_backhand': z.number().nullable().optional(),
  '1b_st_volley': z.number().nullable().optional(),
  '1b_st_lob': z.number().nullable().optional(),
  '1b_st_bajada': z.number().nullable().optional(),
  '1b_st_globo_defensivo': z.number().nullable().optional(),
  '1b_st_chiquita': z.number().nullable().optional(),
  '1b_st_bandeja': z.number().nullable().optional(),
  '1b_st_vibora': z.number().nullable().optional(),
  '1b_st_smash': z.number().nullable().optional(),
  '1b_st_gancho': z.number().nullable().optional(),
  '1b_st_doble_pared': z.number().nullable().optional(),
  '1b_st_drop_shot': z.number().nullable().optional(),
  '1b_st_contra_pared': z.number().nullable().optional(),
  '1b_st_por_tres': z.number().nullable().optional(),
  '1b_st_por_cuatro': z.number().nullable().optional(),
  '1b_pt_empty': z.number().nullable().optional(), // Team 1 empty point types
  '1b_pt_unforced_error': z.number().nullable().optional(),
  '1b_pt_winner': z.number().nullable().optional(),
  '1b_pt_double_fault': z.number().nullable().optional(),
  '1b_pt_other': z.number().nullable().optional(),
  '1g_st_empty': z.number().nullable().optional(), // Team 1 empty shot types
  '1g_st_forehand': z.number().nullable().optional(),
  '1g_st_backhand': z.number().nullable().optional(),
  '1g_st_volley': z.number().nullable().optional(),
  '1g_st_lob': z.number().nullable().optional(),
  '1g_st_bajada': z.number().nullable().optional(),
  '1g_st_globo_defensivo': z.number().nullable().optional(),
  '1g_st_chiquita': z.number().nullable().optional(),
  '1g_st_bandeja': z.number().nullable().optional(),
  '1g_st_vibora': z.number().nullable().optional(),
  '1g_st_smash': z.number().nullable().optional(),
  '1g_st_gancho': z.number().nullable().optional(),
  '1g_st_doble_pared': z.number().nullable().optional(),
  '1g_st_drop_shot': z.number().nullable().optional(),
  '1g_st_contra_pared': z.number().nullable().optional(),
  '1g_st_por_tres': z.number().nullable().optional(),
  '1g_st_por_cuatro': z.number().nullable().optional(),
  '1g_pt_empty': z.number().nullable().optional(), // Team 1 empty point types
  '1g_pt_unforced_error': z.number().nullable().optional(),
  '1g_pt_winner': z.number().nullable().optional(),
  '1g_pt_double_fault': z.number().nullable().optional(),
  '1g_pt_other': z.number().nullable().optional(),
  '2s': z.number().nullable().optional(),
  '21s': z.number().nullable().optional(),
  '22s': z.number().nullable().optional(),
  '2g': z.number().nullable().optional(),
  '2b': z.number().nullable().optional(),
  '2tb': z.number().nullable().optional(),
  '2stb': z.number().nullable().optional(),
  '2brk': z.number().nullable().optional(),
  '21b': z.number().nullable().optional(), // 21 served and lost
  '22b': z.number().nullable().optional(), // 22 served and lost
  '2b_st_empty': z.number().nullable().optional(), // Team 2 empty shot types
  '2b_st_forehand': z.number().nullable().optional(),
  '2b_st_backhand': z.number().nullable().optional(),
  '2b_st_volley': z.number().nullable().optional(),
  '2b_st_lob': z.number().nullable().optional(),
  '2b_st_bajada': z.number().nullable().optional(),
  '2b_st_globo_defensivo': z.number().nullable().optional(),
  '2b_st_chiquita': z.number().nullable().optional(),
  '2b_st_bandeja': z.number().nullable().optional(),
  '2b_st_vibora': z.number().nullable().optional(),
  '2b_st_smash': z.number().nullable().optional(),
  '2b_st_gancho': z.number().nullable().optional(),
  '2b_st_doble_pared': z.number().nullable().optional(),
  '2b_st_drop_shot': z.number().nullable().optional(),
  '2b_st_contra_pared': z.number().nullable().optional(),
  '2b_st_por_tres': z.number().nullable().optional(),
  '2b_st_por_cuatro': z.number().nullable().optional(),
  '2b_pt_empty': z.number().nullable().optional(), // Team 2 empty point types
  '2b_pt_unforced_error': z.number().nullable().optional(),
  '2b_pt_winner': z.number().nullable().optional(),
  '2b_pt_double_fault': z.number().nullable().optional(),
  '2b_pt_other': z.number().nullable().optional(),
  '2g_st_empty': z.number().nullable().optional(), // Team 2 empty shot types
  '2g_st_forehand': z.number().nullable().optional(),
  '2g_st_backhand': z.number().nullable().optional(),
  '2g_st_volley': z.number().nullable().optional(),
  '2g_st_lob': z.number().nullable().optional(),
  '2g_st_bajada': z.number().nullable().optional(),
  '2g_st_globo_defensivo': z.number().nullable().optional(),
  '2g_st_chiquita': z.number().nullable().optional(),
  '2g_st_bandeja': z.number().nullable().optional(),
  '2g_st_vibora': z.number().nullable().optional(),
  '2g_st_smash': z.number().nullable().optional(),
  '2g_st_gancho': z.number().nullable().optional(),
  '2g_st_doble_pared': z.number().nullable().optional(),
  '2g_st_drop_shot': z.number().nullable().optional(),
  '2g_st_contra_pared': z.number().nullable().optional(),
  '2g_st_por_tres': z.number().nullable().optional(),
  '2g_st_por_cuatro': z.number().nullable().optional(),
  '2g_pt_empty': z.number().nullable().optional(), // Team 2 empty point types
  '2g_pt_unforced_error': z.number().nullable().optional(),
  '2g_pt_winner': z.number().nullable().optional(),
  '2g_pt_double_fault': z.number().nullable().optional(),
  '2g_pt_other': z.number().nullable().optional(),
  'show_comments': z.boolean().nullable().optional(),
  'show_court_map': z.boolean().nullable().optional()
})

const BallSchema = z.object({
  id: z.number(),
  match_set_id: z.number(),
  server: z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)]),
  winner: z.union([z.literal(1), z.literal(2)]),
  ball_type: z.enum(['default', 'golden_ball', 'tie_break', 'super_tie_break']),
  shot_type: z.string().nullable().optional(),
  won_game: z.boolean().nullable().optional(),
  point_type: z.string().nullable().optional(),
  team1_points: z.string().nullable().optional(),
  team2_points: z.string().nullable().optional(),
  team1_games: z.number().nullable().optional(),
  team2_games: z.number().nullable().optional(),
  from_x: z.number().nullable().optional(),
  from_y: z.number().nullable().optional(),
  to_x: z.number().nullable().optional(),
  to_y: z.number().nullable().optional(),
  finisher: z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)]).nullable().optional(),
  comment: z.string().nullable().optional()
})

export const BallsIndexResponseSchema = z.object({
  balls: z.array(BallSchema)
})

const MatchScreenSchema = z.object({
  screen_id: z.number(),
  name: z.string(),
  show_priority: z.number(),
})

const MatchSetSchema = z.object({
  id: z.number(),
  set_number: z.number(),
  set_type: z.enum(['default', 'super_tie_break']),
  team1_won: z.boolean().nullable(),
  team1_won_at: z.string().nullable(),
  games_1: z.number().nullable(),
  games_2: z.number().nullable(),
  tiebreaks_1: z.number().nullable(),
  tiebreaks_2: z.number().nullable(),
  statistics: StatisticsSchema.nullable()
})

export const MatchSchema = z.object({
  id: z.number(),
  hash: z.number().nullable(),
  created_at: z.string(),
  updated_at: z.string(),
  start_showing_at: z.string(),
  stop_showing_at: z.string().nullable(),
  started_at: z.string().nullable(),
  finished_at: z.string().nullable(),
  visibility: z.enum(['public', 'internal', 'private']),
  background_type: z.enum(['default', 'gradient']).nullable(),
  competitor1_won: z.boolean().nullable(),
  // competitor_1: CompetitorSchema,
  // competitor_2: CompetitorSchema,
  games_end_with_golden_ball: z.boolean(),
  end_match_with_tie_break: z.boolean(),
  show_server: z.boolean(),
  organization_id: z.number(),
  match_title: z.string(),
  match_description: z.string().optional().nullable(),
  match_sets: z.array(MatchSetSchema),
  screen_priorities: z.array(MatchScreenSchema),
  players: z.array(MatchPlayerSchema),
  show_priority: z.number().optional(),
  coach_match: z.boolean().optional(),
  points: z.object({
    '1': z.string(),
    '2': z.string(),
    'b_id': z.number().nullable().optional(),
    'golden': z.boolean().optional(),
    'tie_break': z.boolean().optional(),
    '1_comment': z.string().nullable(),
    '2_comment': z.string().nullable(),
    '1_winner': z.boolean().nullable(),
    '1_won_set': z.boolean().nullable().optional(),
    'last_ball_id': z.number().nullable(),
    'next_server_id': z.number().nullable().optional(),
    'b_updated_at': z.string().nullable().optional()
  }).nullable()
})

export const MatchIndexResponseSchema = z.object({
  matches: z.array(MatchSchema),
})

// WebSocket message schemas
export const MatchUpdateSchema = z.object({
  identifier: z.string(),
  message: z.string()
})

export const MatchListUpdateSchema = z.object({
  identifier: z.string(),
  message: z.string()
})

export const OrganizationSchema = z.object({
  id: z.number(),
  name: z.string(),
  auth_code: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
})

export type MatchPlayer = z.infer<typeof MatchPlayerSchema>
export type Match = z.infer<typeof MatchSchema>
export type MatchSet = z.infer<typeof MatchSetSchema>
export type Competitor = z.infer<typeof CompetitorSchema>
export type Ball = z.infer<typeof BallSchema>
export type BallsIndexResponse = z.infer<typeof BallsIndexResponseSchema>
export type MatchIndexResponse = z.infer<typeof MatchIndexResponseSchema>
export type WebSocketMessage = z.infer<typeof MatchUpdateSchema> | z.infer<typeof MatchListUpdateSchema>
export type Organization = z.infer<typeof OrganizationSchema>
export type Statistics = z.infer<typeof StatisticsSchema>
